// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uc-h","index":"styles_index__1GL1t"};